import { FC, ReactNode } from "react";
import { useAppSelector } from "@/shared/hooks/appHooks";
import {
  AuthenticationState,
  selectIsAuthenticated,
} from "@motain/web-shared-hub/features";
import { ExternalRoutes } from "@/shared/constants/Routes";
import { QUERY_PARAMS } from "@motain/web-shared-hub/constants";
import { LogoLoadingSpinnerCentered } from "@motain/web-shared-hub/ui/blocks";

interface ProtectedRouteProps {
  children: ReactNode;
}

export const OF_LOGIN_URL = `${ExternalRoutes.OF_LOGIN}?${QUERY_PARAMS.redirect}`;
export const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const authState = useAppSelector(selectIsAuthenticated);

  if (authState === AuthenticationState.UnAuthenticated) {
    const currentUrl = window.location.href;
    window.location.href = `${OF_LOGIN_URL}=${currentUrl}`;
    return null;
  }

  if (authState === AuthenticationState.Unknown) {
    return (
      <div data-testid="spinner">
        <LogoLoadingSpinnerCentered />;
      </div>
    );
  }

  if (authState === AuthenticationState.Authenticated) {
    return <>{children}</>;
  }
};
